import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useReadOtherParticipation = () => {

    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ otherParticipation, setOtherParticipation ] = useState([]);
    const [ fetchingOtherParticipation, setFetchingOtherParticipation ] = useState(true);

    /** read one to one
     * @param {integer} userId - user id
     * * @param {integer} participationId - one to one id id
     * @returns {object} - one to one */ 
    const readOtherParticipation = async (userId, participationId) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingOtherParticipation')});
            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);

            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/users/" + userId + "/participations/" + participationId, options);

            removeMessage(msgId);

            if (result && result.status === 200) {
                setOtherParticipation(result);
                setFetchingOtherParticipation(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.otherParticipationNotFound') });
                setFetchingOtherParticipation(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingOtherParticipationFailed') });
            setFetchingOtherParticipation(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingOtherParticipationFailed') });
            setFetchingOtherParticipation(false);
            return error;
        }
    }

    return { otherParticipation, fetchingOtherParticipation, readOtherParticipation };

}

export default useReadOtherParticipation;
